module.exports = __webpack_public_path__ + "media/DreamRoom.0e03b8ac.mp4";